<script lang="ts" setup>
const route = useRoute()
const { data: page } = await useAsyncData(route.path, () => {
  return queryCollection('content').path(route.path).first()
})

useHead(page.value?.head || {})
useSeoMeta(page.value?.seo || {})
</script>

<template>
  <ApplicationPage :title="page?.title ?? ''" :image="page?.image">
    <ContentRenderer
      v-if="page"
      class="
        dark:prose-a:decoration-primary-600
        dark:prose-a:text-primary-200
        dark:prose-headings:text-primary-50
        dark:prose-invert
        max-w-screen-md
        mx-auto
        p-4
        prose
        prose-a:cursor-pointer
        prose-a:decoration-primary-100
        prose-a:hover:underline
        prose-a:no-underline
        prose-a:text-primary-600
        prose-headings:font-heading
        prose-headings:text-primary-800
        lg:prose-lg
        lg:px-0
        lg:py-20
        xl:prose-xl
      "
      :prose="false"
      :value="page"
    />
  </ApplicationPage>
</template>
